'use client';

import React, { FC, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import Button from '../../../components/button/button';
import FormCheckbox from '../../../components/formCheckbox/FormCheckbox';
import PDFViewer, { PdfMenu } from '../../../components/pdfViewer/PDFViewer';
import useReportGenerator from '../../../hooks/useReportGenerator';
import useRiskTransferStore from '../../../store/RiskTransferStore';
import { ReportHandler } from '../../ReportPage/Report';
import styles from '../RiskTransfer.module.scss';

interface AbsorbForm {
  canAbsord: string;
}

const RiskManagementSummarySection: FC<ReportHandler> = ({ validChanged }) => {
  const { generateReportHook } = useReportGenerator(
    'riskManagementSummaryReport'
  );
  const {
    setRiskManagementSummaryReportPDF,
    riskManagementSummaryReportPDF,
    setCanAbsorbRisk,
    canAbsorbRisk,
  } = useRiskTransferStore();

  const formMethods = useForm<AbsorbForm>();
  const {
    formState: { isValid },
    setValue,
  } = formMethods;

  const [menus, setMenus] = useState<PdfMenu[]>([]);
  const [showPDF, setShowPDF] = useState<boolean>(false);

  useEffect(() => {
    setMenus([
      {
        label: 'Generate Form Summary Report',
        callback: () => {
          generateReportHook();
        },
      },
    ]);

    if (canAbsorbRisk != null) {
      setValue('canAbsord', canAbsorbRisk ? 'yes' : 'no');
    }
  }, []);

  useEffect(() => {
    if (showPDF) {
      validChanged(isValid && riskManagementSummaryReportPDF != null);
    } else {
      validChanged(isValid);
    }
  }, [isValid, riskManagementSummaryReportPDF, showPDF]);

  return (
    <div className={styles.riskManagementSummaryMain}>
      <FormProvider {...formMethods}>
        <FormCheckbox
          id="canAbsord"
          required
          label="Can the company internally absorbed the above risks?"
          options={[
            { label: 'Yes, we can internally absorb the risks', value: 'yes' },
            { label: 'No, we need to transfer out the risks.', value: 'no' },
          ]}
          valueChanged={(val) => {
            setShowPDF(val == 'no');
            if (val == 'yes') {
              setRiskManagementSummaryReportPDF(null);
              setCanAbsorbRisk(true);
            } else if (val == 'no') {
              setCanAbsorbRisk(false);
            }
          }}
        />
      </FormProvider>

      {showPDF && (
        <PDFViewer
          type={'riskManagementSummaryReport'}
          menus={menus}
          className={styles.riskManagementPDF}
        >
          <Button onClick={() => generateReportHook()}>
            Generate Form Summary Report
          </Button>
        </PDFViewer>
      )}
    </div>
  );
};

export default RiskManagementSummarySection;
